<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid>

                <v-tabs v-model="activeTab" color="primary" dark slider-color="white" centered icons-and-text>
                    <v-tab ripple>Overview<v-icon>view_stream</v-icon></v-tab>
                    <v-tab ripple>Detailed<v-icon>view_module</v-icon></v-tab>

                    <!-- Simple -->
                    <v-tab-item>
                        <v-card elevation-1>
                            <v-container grid-list-xs text-xs-center fluid pa-3>
                            <v-layout row wrap>
                                <v-flex xs2 class="mr-3">
                                    <v-dialog ref="fromDateDialog" v-model="fromDateModal" :return-value.sync="fromDate" persistent lazy full-width width="290px">
                                        <v-text-field slot="activator" v-model="fromDate" label="From Date" append-icon="event" readonly></v-text-field>
                                        <v-date-picker v-model="fromDate" scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn flat color="primary" @click="fromDateModal = false">Cancel</v-btn>
                                            <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-flex>
                                <v-flex xs2>
                                    <v-dialog ref="toDateDialog" v-model="toDateModal" :return-value.sync="toDate" persistent lazy full-width width="290px">
                                        <v-text-field slot="activator" v-model="toDate" label="To Date" append-icon="event" readonly></v-text-field>
                                        <v-date-picker v-model="toDate" scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn flat color="primary" @click="toDateModal = false">Cancel</v-btn>
                                            <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-flex>
                            </v-layout>

                            <v-layout>
                                <v-flex xs12>
                                    <v-data-table :headers="tableHeaders1" :items="tableData1" :loading="loading1" hide-actions>
                                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left vertical-header">{{ props.item.name }}</td>
                                            <td class="text-xs-left">{{ props.item.merchant_name }}</td>
                                            <td class="text-xs-center">{{ transactionRate(props.item.transaction_rate) }}p</td>
                                            <td class="text-xs-center">{{ props.item.volume }}</td>
                                            <td class="text-xs-center">{{ new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'GBP' }).format(props.item.value) }}</td>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                            </v-container>
                        </v-card>
                    </v-tab-item>

                     <!-- Extended -->
                    <v-tab-item>
                        <v-card elevation-1>
                            <v-container grid-list-xs text-xs-center fluid pa-3>
                            <v-layout row wrap>
                                <v-flex xs2 class="mr-3">
                                    <v-select v-model="staff" dense :items="staffOptions" item-text="name" item-value="id" label="Staff Member" append-icon="search" @change="loading2 = true; getSingleSalesStaffReport();"></v-select>
                                </v-flex>
                                <v-flex xs2>
                                    <v-text-field v-model="merchantName" append-icon="search" label="Merchant Name" clearable @change="getSingleSalesStaffReport" @click:clear="merchantName = null; getSingleSalesStaffReport();"></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout>
                                <v-flex xs12>
                                    <v-data-table :headers="tableHeaders2" :items="tableData2" :loading="loading2" hide-actions>
                                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left vertical-header">{{ props.item.month }} {{ props.item.year }}</td>
                                            <td class="text-xs-left">{{ props.item.merchant_name }}</td>
                                            <td class="text-xs-center">{{ transactionRate(props.item.transaction_rate) }}p</td>
                                            <td class="text-xs-center">{{ props.item.volume }}</td>
                                            <td class="text-xs-center">{{ new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'GBP' }).format(props.item.value) }}</td>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                            </v-container>
                        </v-card>
                    </v-tab-item>
                </v-tabs>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
    data() {
        return {
            fromDateModal: false,
            toDateModal: false,
            fromDate: moment().startOf('month').format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
            tableData1: [],
            tableData2: [],
            loading1: true,
            loading2: false,
            tableHeaders1: [{ text: 'Staff Member', sortable: false },
                            { text: 'Merchant', sortable: false },
                            { text: 'Transaction Rate', sortable: false, align: 'center' },
                            { text: 'Volume', sortable: false, align: 'center' },
                            { text: 'Value', sortable: false, align: 'center' }],
            tableHeaders2: [{ text: 'Month', sortable: false },
                            { text: 'Merchant Name', sortable: false },
                            { text: 'Transaction Rate', sortable: false, align: 'center' },
                            { text: 'Volume', sortable: false, align: 'center' },
                            { text: 'Value', sortable: false, align: 'center' }],
            staff: null,
            staffOptions: [],
            merchantName: null,

            activeTab: null,
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
        }
    },
    beforeMount() {
        this.getSalesStaffReport();
        this.getSalesStaffMembers();
    },
    methods: {
        getSalesStaffReport() {
            axios({
            method: 'post',
            url: 'https://controlapi.totalprocessing.com/api/get-sales-staff',
            data: { fromDate: this.fromDate, toDate: this.toDate },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.loading1 = false;
                this.tableData1 = response.data;

                let name = '';
                let length = this.tableData1.length;

                this.tableData1.forEach(function(row, pos) {
                    if(pos < length) {
                        if(row.name == name) {
                            row.name = '';
                        }
                        else {
                            name = row.name;
                        }
                    }
                });
                
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getSalesStaffMembers() {
            axios({
                method: 'get',
                url: 'https://controlapi.totalprocessing.com/api/get-sales-staff-members',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    response.data.forEach(row => {
                        return row.name = row.first_name + ' ' + row.surname;
                    });
                    this.staff = response.data[0].id;
                    this.staffOptions = response.data;
  
                    this.getSingleSalesStaffReport();
                })
                .catch(e => {
                    this.errors.push(e)
                })
        },
        getSingleSalesStaffReport() {
            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/get-single-sales-staff',
                data: { userId: this.staff, merchantName: this.merchantName },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.loading2 = false;
                    this.tableData2 = response.data;

                    let month = '';
                    let year = '';
                    let length = this.tableData2.length;

                    this.tableData2.forEach(function(row, pos) {
                        if(pos < length) {
                            if(row.month == month) {
                                row.month = '';
                                row.year = '';
                            }
                            else {
                                month = row.month;
                                year = row.year;
                            }
                        }
                    });
                    
                })
                .catch(e => {
                    this.errors.push(e)
                })
        },
        transactionRate(rate) {
            if(rate.substring(rate.length-1) == '0') {
                return rate.substring(0, rate.length-1);
            }
            else {
                return rate;
            }
        },
        handleDateChange() {
            this.loading = true;
            if(this.toDate < this.fromDate) {
                this.fromDate = this.toDate;
            }
            this.$refs.fromDateDialog.save(this.fromDate);
            this.$refs.toDateDialog.save(this.toDate);
            this.getSalesStaffReport();
        }
    }
}
</script>
    
<style>

</style>
